import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const KEY = 'cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (!v) setVisible(true);
    } catch {}
  }, []);

  if (!visible) return null;

  const set = (val) => {
    try { localStorage.setItem(KEY, val); } catch {}
    setVisible(false);
  };

  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md bg-[#0A1F44] text-white rounded-2xl shadow-2xl p-5 z-50 border border-white/10">
      <button onClick={() => set('rejected')} className="absolute top-3 right-3 text-white/50 hover:text-white" aria-label="Lukk">
        <X size={18} />
      </button>
      <div className="text-sm leading-relaxed pr-6">
        Vi bruker informasjonskapsler for å forbedre opplevelsen og forstå bruken av nettstedet. Les vår <Link to="/cookies" className="underline hover:text-[#3B82F6]">cookiepolicy</Link>.
      </div>
      <div className="mt-4 flex gap-2">
        <button
          data-testid="cookie-accept"
          onClick={() => set('accepted')}
          className="bg-[#3B82F6] hover:bg-[#2563EB] text-white px-5 py-2 rounded-full text-sm font-semibold transition-colors flex-1"
        >
          Godta
        </button>
        <button
          data-testid="cookie-reject"
          onClick={() => set('rejected')}
          className="bg-transparent hover:bg-white/10 text-white/80 px-5 py-2 rounded-full text-sm border border-white/20 transition-colors"
        >
          Avvis
        </button>
      </div>
    </div>
  );
}
